"use strict";

exports.__esModule = true;
exports.AggregateMeasureTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _DataTable = require("../../Core/DataTable");
var _SelectionContext = require("../../Core/SelectionContext");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _helpers = require("../DataTable/helpers");
var _AggregateMeasureTable = require("./AggregateMeasureTable");
var _EmptySelectionTable = require("./EmptySelectionTable");
var _generateTableProps = require("./generateTableProps");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AggregateMeasureTableElement = exports.AggregateMeasureTableElement = (0, _reactRouterCompat.withRouter)(function (props) {
  var configuration = props.configuration,
    children = props.children,
    dataSource = props.dataSource,
    dataRange = props.dataRange,
    height = props.height,
    width = props.width,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection;
  var selection = _react["default"].useContext(_SelectionContext.SelectionContext);
  var defaultPageSize = (0, _helpers.nearestIndexInPageSizeList)([5, 10, 25, 100], (0, _helpers.getDefaultPageSize)(configuration, height) < 0 ? 0 : (0, _helpers.getDefaultPageSize)(configuration, height));
  var _useState = (0, _react.useState)({
      page: 0,
      pageSize: defaultPageSize
    }),
    pagination = _useState[0],
    setPagination = _useState[1];

  // Columns are configured on child elements but rendered by the table so gather up the configs
  var columns = children.map(function (child) {
    return Object.assign({}, child.props);
  });
  var measureColumnIds = [];
  var dimensionColumnIds = [];
  var timeAggregationColumnIds = [];

  // Columns need to be updated to match the response
  columns = columns.map(function (column) {
    if (column.dataType === "measures") {
      measureColumnIds.push(column.id);
      return Object.assign({}, column, {
        id: column.id.replace(".", "-")
      });
    } else if (column.dataType === "dimensions" && column.groupId !== "time_group") {
      dimensionColumnIds.push(column.id);
      var id = "by_" + (column.id.split(".")[1] || column.id);
      return Object.assign({}, column, {
        id: id
      });
    } else {
      timeAggregationColumnIds.push(column.id);
      return column;
    }
  });
  var timeGroup = _timeAggregationBinMapping.timeGrouping.find(function (t) {
    return t.binName === timeAggregationColumnIds[0] || false;
  });
  var windowType = (timeGroup == null ? void 0 : timeGroup.name) || "";
  var tableProps = (0, _generateTableProps.generateTableProps)({
    columns: columns,
    configuration: configuration,
    height: height,
    width: width,
    pagination: pagination,
    setPagination: setPagination
  });
  if (selection.isSelectionEmpty(dataRange, fetchDataOnlyOnSelection)) {
    return /*#__PURE__*/_react["default"].createElement(_EmptySelectionTable.EmptySelectionTable, {
      tableProps: tableProps,
      columns: columns
    });
  }
  var showNoDataTable = !dataSource || columns.length === 0 || measureColumnIds.length === 0 || timeAggregationColumnIds.length > 1;

  /** No data table is shown if -
   * 1. No columns are present
   * 2. No measure columns are present
   * 3. If more than one time aggregates are present */
  if (showNoDataTable) {
    var noDataText = "Make selection to view data";
    if (timeAggregationColumnIds.length > 1) {
      noDataText = "Please select a single time period";
    } else if (measureColumnIds.length === 0) {
      noDataText = "Please select a measure";
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "aggregate-measure-table-element"
    }, /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, _extends({}, tableProps, {
      loading: false,
      columns: [],
      data: [],
      pages: 1,
      noDataText: noDataText
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_AggregateMeasureTable.AggregateMeasureTable, {
    height: height,
    width: width,
    dataSource: dataSource,
    dataRange: dataRange,
    tableProps: tableProps,
    pagination: pagination,
    dimensionColumnIds: dimensionColumnIds,
    measureColumnIds: measureColumnIds,
    columns: columns,
    windowType: windowType
  });
});